import React, { useEffect } from 'react'
import { Route } from 'react-router-dom'
import { IntercomProvider } from 'react-use-intercom'

import { CabinAndDeviceActivityTable } from '../Activity/MassEdit/CabinAndDeviceTable'
import { ActivityTable } from '../Activity/MassEdit/Table'
import { default as ActivityTranslation } from '../Activity/Translation/Translation'
import { CalendarBootstrap } from '../Calendar/CalendarBootstrap'
import { SurveyBootstrap } from '../Customer/Survey/SurveyBootStrap'
import { default as DepositOverview } from '../Deposit/Overview/Overview'
import { getEstablishment } from '../Establishment/Store/actions'
import { EstablishmentStats } from '../EstablishmentStats'
import { HealthInsuranceN } from '../HealthInsuranceN/HealthInsuranceN'
import { AbsenceBootstrap } from '../HR/AbsenceNew/Bootstrap'
import { AbsenceRequestsBootstrap } from '../HR/AbsenceRequests/Bootstrap/Bootstrap'
import { ContractBootstrap } from '../HR/Contract/Bootstrap'
import { GeneralAbsenceBootstrap } from '../HR/GeneralAbsence/Bootstrap'
import { Knowledge } from '../HR/Knowledge/Knowledge'
import PersonTargetsBootstrap from '../HR/PersonTargets/Bootstrap/Bootstrap'
import { Overview as PunchclockOverview } from '../HR/Punchclock/Overview/Overview'
import { Invoice } from '../Invoice'
import LegacyCalendarBootstrap from '../LegacyCalendar/Bootstrap/Bootstrap'
import TrashCan from '../LegacyCalendar/TrashCan/TrashCan'
import { default as ProductsTable } from '../Product/MassEdit/Table'
import { ProfileBootstrap } from '../Profile/Bootstrap/Bootstrap'
import { Referral } from '../Referral/Referral'
import { CustomerSubscription } from '../Register/CustomerSubscription'
import { Bootstrap as ReportBootstrap } from '../Report/Bootstrap/Bootstrap'
import ReportHrTime from '../Report/HRTime'
import { default as SkinTrackDetail } from '../SkinTrack/Detail/Detail'
import { default as SkinTrackOverview } from '../SkinTrack/Overview/Overview'
import { SubscriptionBootstrap } from '../Subscription'
import PermissionList from '../User/Permission/List/List'
import { getCurrentUser } from '../User/Store/actions'
import { Webinars } from '../Webinars/Webinars'

import Spinner from './Components/Spinner/Spinner'
import { useAppDispatch, useAppSelector } from './Hooks/reduxHooks'

export const PrivateRoutes = () => {
  const dispatch = useAppDispatch()
  const INTERCOM_APP_ID = 'w8mpt8ca'
  const onHide = React.useCallback(
    () => console.log('Intercom did hide the Messenger'),
    [],
  )

  const establishment = useAppSelector(state => state.establishment)
  const users = useAppSelector(state => state.users)

  useEffect(() => {
    dispatch(getEstablishment())
    dispatch(getCurrentUser())
  }, [])

  if (!establishment.active || !users.currentUser) {
    return <Spinner />
  }

  return (
    <IntercomProvider appId={INTERCOM_APP_ID} onHide={onHide}>
      <Route path="/subscription" component={SubscriptionBootstrap} />
      <Route path="/customers/surveys" component={SurveyBootstrap} />
      <Route
        path="/customers/:customerId/skin-track/:limb/:revision?"
        component={SkinTrackDetail}
      />
      <Route
        path="/customers/:customerId/skin-track"
        component={SkinTrackOverview}
      />
      <Route
        path="/register/customer-subscriptions"
        component={CustomerSubscription}
      />
      <Route path="/register/deposits" component={DepositOverview} />
      <Route exact path="/register/invoice/add" component={Invoice} />
      <Route path="/report" component={ReportBootstrap} />
      <Route
        path="/register/health-insurance/add/:receiptId?"
        component={HealthInsuranceN}
      />
      <Route path="/settings/activities/mass-edit" component={ActivityTable} />
      <Route
        path="/settings/activities/mass-edit-cabins-devices"
        component={CabinAndDeviceActivityTable}
      />
      <Route path="/products/mass-edit" component={ProductsTable} />
      <Route
        path="/settings/activity-translations"
        component={ActivityTranslation}
      />
      <Route
        path="/settings/user/:userId/permissions"
        render={injectedProps => (
          <PermissionList userId={Number(injectedProps.match.params.userId)} />
        )}
      />

      <Route path="/settings/referrals" component={Referral} />
      <Route path="/profile" component={ProfileBootstrap} />
      <Route path="/calendar-new" component={CalendarBootstrap} />
      <Route path="/calendar" component={LegacyCalendarBootstrap} />
      <Route path="/hr/knowledge/:personUuid" component={Knowledge} />

      <Route path="/hr/absences" component={AbsenceBootstrap} />
      <Route path="/hr/general-absences" component={GeneralAbsenceBootstrap} />
      <Route path="/hr/absence-requests" component={AbsenceRequestsBootstrap} />

      <Route path="/hr/persons" exact component={PunchclockOverview} />
      <Route path="/hr/persons/contracts" component={ContractBootstrap} />
      <Route path="/hr/targets" component={PersonTargetsBootstrap} />

      <Route path="/report/hr-time" component={ReportHrTime} />
      <Route path="/calendar-trash" component={TrashCan} />
      <Route path="/webinars" component={Webinars} />
      <Route
        path="/report/establishment-stats"
        component={EstablishmentStats}
      />
    </IntercomProvider>
  )
}
